import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Add"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_1540_42084)"><rect x="2" y="11" width="20" height="2" rx="1" fill="#E0E4EA"></rect><rect x="11" y="22" width="20" height="2" rx="1" transform="rotate(-90 11 22)" fill="#E0E4EA"></rect></g><defs><clipPath id="clip0_1540_42084"><rect width="24" height="24" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var Add = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Add as default };
